class UserService {
  static getFullName(dto: Partial<{ first_name: string; last_name: string }>) {
    return [dto.first_name, dto.last_name].filter(Boolean).join(' ')
  }
}

export { UserService }
